import React from "react";
import SEO from "./SEO";

function About() {
  return (
    <section id="about" className="about" aria-labelledby="about-title">
      <SEO
        title="About Sukun - Cloud & DevOps Expert"
        description="Learn about Sukun Cloud Consulting – expert in GCP, AWS, Kubernetes, GitOps, and building globally distributed infrastructure."
        keywords={["Sukun", "Cloud Consultant", "DevOps", "Kubernetes", "GCP", "AWS", "GitOps"]}
      />
      <h2 id="about-title">About Sukun - Cloud & DevOps Consultant</h2>
      <p>At Sukun Cloud Consulting, we specialize in scaling mission-critical infrastructure with over 2000+ servers and 500M+ emails/day. Our expertise spans Google Cloud (GCP), Amazon Web Services (AWS), Kubernetes, Terraform, GitOps, and building globally resilient distributed systems.</p>
    </section>
  );
}

export default About;